module.exports = __webpack_public_path__ + "static/cubes-8a3d86c4bd2b40114c8f8603a954fa7a.png";